import { ApiResponse } from '@nf/types/api';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '@/hooks/query/use-api-backend-info';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { useLicSettings } from '@/domains/config/hooks/use-lic-settings';
import { ApiBackendInfo } from '@/hooks/query/athena/types';
import { WcPromotionPoolSummary } from './types';
import { WC_PROMOTION_AVAILABLE_PRIZE_POOLS_CACHE_MS } from './constants';

const fetchWcPromotionAllPools = async (
	apiBackendInfo: ApiBackendInfo
): Promise<ApiResponse<WcPromotionPoolSummary[]>> => {
	const response = await fetchComposer.getWithBearer(
		`${apiBackendInfo.url}/WcPromotion/GetAllPools`
	)(apiBackendInfo.token);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};


// 取得所有的獎池, 使用在 weekly lottery 上方的 dropdown
export const useWcPromotionAllPools = () => {
	const { enableWcPromotionLuckySpin, enableWcPromotionWeeklyLottery, enableWcPromotionAfterParty } = useLicSettings();
	const apiBackendInfo = useApiBackendInfo();
	const isWcPromotionEnabled = enableWcPromotionLuckySpin || enableWcPromotionWeeklyLottery || enableWcPromotionAfterParty;

	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [
			queryKeys.WC_PROMOTION_ALL_POOLS,
			apiBackendInfo.url,
			apiBackendInfo.token
		],
		queryFn: () => fetchWcPromotionAllPools(apiBackendInfo),
		staleTime: WC_PROMOTION_AVAILABLE_PRIZE_POOLS_CACHE_MS,
		cacheTime: WC_PROMOTION_AVAILABLE_PRIZE_POOLS_CACHE_MS,
		refetchInterval: WC_PROMOTION_AVAILABLE_PRIZE_POOLS_CACHE_MS,
		enabled: isWcPromotionEnabled && apiBackendInfo.isReady
	});

	return {
		data: data?.Data ?? [],
		isLoading,
		isError,
		error,
		refetch
	};
};
